<template>
    <div>
        <div class="form-group col-12">
            <b>Content:</b>

            <p>{{ request.content }}</p>

            <div class="invalid-feedback">
                {{ getError('stars') }}
            </div>
        </div>
        <div class="form-group col-12">
            <b>Type:</b>

            <p>{{ request.type }}</p>
        </div>

        <div class="form-group col-12">
            <b>Note:</b>

            <p v-if="isAnswered">
                {{ request.note }}
            </p>

            <textarea
                v-else
                id="note"
                v-model="request.note"
                :disabled="isAnswered"
                class="form-control rtl"
                dir="auto"
            />
            <div class="invalid-feedback">
                {{ getError('note') }}
            </div>
        </div>

        <template v-if="!isAnswered">
            <div class="form-group col-12">
                <label>Grant stars?</label>
                <b-form-checkbox v-model="addStars" switch />
            </div>

            <div v-if="addStars" class="form-group col-12">
                <label for="stars">Stars</label>
                <input
                    id="stars"
                    v-model.number="request.stars"
                    type="number"
                    class="form-control"
                    :class="{
                        'is-invalid': hasError('stars')
                    }"
                    dir="auto"
                />
                <div class="invalid-feedback">
                    {{ getError('stars') }}
                </div>
            </div>
        </template>

        <div v-if="isAnswered && request.stars" class="form-group col-12">
            <b>Stars granted</b>: {{ request.stars }}
        </div>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            type: Object,
            required: false,
            default: () => ({})
        },
        validation: {
            type: Object,
            required: true
        },
        serverErrors: {
            type: Array,
            required: true
        },
        isAnswered: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            addStars: false,
            request: {}
        };
    },

    watch: {
        addStars() {
            if (!this.addStars) {
                this.request.stars = 0;
            }
        },

        request() {
            this.$emit('input', this.request);
        }
    },

    created() {
        this.request = { ...this.value };
    },

    methods: {
        hasError(key) {
            return (
                (this.validation.request[key] &&
                    this.validation.request[key].$error) ||
                this.serverErrors.find(error => error.param === key)
            );
        },

        getError(key) {
            return this.$getValidationErrorMessageHandler.handle(
                this.validation.request,
                this.serverErrors,
                key
            );
        }
    }
};
</script>
